import { create } from "zustand";
import type { Session } from "@supabase/supabase-js";

type AuthState = {
  initialized: boolean;
  session: Session | null;
  setSession: (session: Session | null) => void;
  setInitialized: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  initialized: false,
  session: null,
  setSession: (session) => set({ session }),
  setInitialized: () => set({ initialized: true }),
}));
